import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IconsRegistry } from '@iac-services';
import { StoryblokService } from '@iac-storyblok';
import { completeIconSet } from '@iac-types';

@Component({
  selector: 'iac-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly iconRegistry = inject(IconsRegistry);
  private readonly storyblokService = inject(StoryblokService);

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.iconRegistry.registerIcons(completeIconSet);
    this.storyblokService.initStoryblokBridgeAndEditMode();
  }
}
